module.exports = __webpack_public_path__ + "static/media/proj6.e571d54a.jpg";